var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box right"},[_c('article',[_c('a',{attrs:{"href":_vm.adLink}},[_c('img',{staticClass:"banner",attrs:{"src":require(("@/static/img/ad/" + _vm.adImg))}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }